import * as React from 'react';
import { PackageQuantityDropdown } from '../../../../ConfigureContactLenses/components/PackageQuantityDropdown/PackageQuantityDropdown.js';

const isPowerAttribute = (attr)=>{
    return attr.name === 'power';
};
const findPowerAttribute = (variant)=>{
    var ref1;
    return variant === null || variant === void 0 ? void 0 : (ref1 = variant.attributes) === null || ref1 === void 0 ? void 0 : ref1.find(isPowerAttribute);
};
var _sku, ref;
const mappedDropdownItems = (variants)=>{
    return variants.reduce((acc, curr)=>{
        var ref2;
        return findPowerAttribute(curr) ? acc.push({
            value: (_sku = curr.sku) !== null && _sku !== void 0 ? _sku : '',
            label: (ref = (ref2 = findPowerAttribute(curr)) === null || ref2 === void 0 ? void 0 : ref2.value) !== null && ref !== void 0 ? ref : ''
        }) : null, acc;
    }, []);
};
const sortedDropdownItems = (mappedItems)=>mappedItems.sort((a, b)=>+a.value - +b.value
    )
;
const PowerSelector = ({ activeSku , handleVariantPick , variants  })=>{
    var ref3;
    const items = React.useMemo(()=>mappedDropdownItems(variants)
    , [
        variants
    ]);
    const sortedItems = React.useMemo(()=>sortedDropdownItems(items)
    , [
        items
    ]);
    const selectedSize = (ref3 = items.find((item)=>item.value === activeSku
    )) === null || ref3 === void 0 ? void 0 : ref3.value;
    return /*#__PURE__*/ React.createElement(PackageQuantityDropdown, {
        title: "ready-readers-power-selector",
        onChange: (selectedVariant)=>handleVariantPick(selectedVariant.label, undefined, selectedVariant.value)
        ,
        selectedSize: selectedSize,
        items: sortedItems
    });
};

export { PowerSelector, mappedDropdownItems, sortedDropdownItems };
//# sourceMappingURL=PowerSelector.js.map
